const ContractDetail = {
  'pages_contract_ContractDetail.contractinfo': '계약 정보',
  'pages_contract_ContractDetail.contractinfo.detail': '계약 정보 상세',
  'pages_contract_ContractDetail.contract.ing': '계약 진행',
  'pages_contract_ContractDetail.contract.needextend': '계약 연장',
  'pages_contract_ContractDetail.contract.end': '계약 종료',
  'pages_contract_ContractDetail.contract.exceed': '종료 예정',
  'pages_contract_ContractDetail.includeVat': 'VAT 포함',
  'pages_contract_ContractDetail.contract.date': '계약일',
  'pages_contract_ContractDetail.contract.startDate': '시작일',
  'pages_contract_ContractDetail.contract.endDate': '종료일',
  'pages_contract_ContractDetail.contract.invoiceDocumentDate': '청구일',
  'pages_contract_ContractDetail.contract.paymethodName': '지급 방법',
  'pages_contract_ContractDetail.contract.termsOfPaymentKey': '지급 조건',
  'pages_contract_ContractDetail.contract.termsOfPaymentName': '증빙일 기준 익월 말일',
  'pages_contract_ContractDetail.salese.salesInfo': '영업 담당자 정보',
  'pages_contract_ContractDetail.salese.sales.name': '담당자',
  'pages_contract_ContractDetail.salese.sales.telNo': '전화번호',
  'pages_contract_ContractDetail.salese.sales.email': '이메일',
  'pages_contract_ContractDetail.salese.billInfo': '빌링 담당자 정보',
  'pages_contract_ContractDetail.contract.productByKrw': '상품별 비용',
  'pages_contract_ContractDetail.productName': '상품명',
  'pages_contract_ContractDetail.contract.contractStatusName': '계약 상태',
  'pages_contract_ContractDetail.contract.productKrw': '상품 비용',
  'pages_contract_ContractDetail.no.auth': '접근 권한이 없습니다',
  'pages_contract_ContractDetail.contract.product.startDate': '상품 시작일',
  'pages_contract_ContractDetail.contract.product.endDate': '상품 종료일',
}

export default ContractDetail



// WEBPACK FOOTER //
// ./src/lang/contract/ContractDetail.kr.js